<template>
<div class="chapter">
<div class="inner_page">
<table class="chapter-title-corner-decorations" width="100%"><tbody><tr><td class="chapter-title-corner-decoration-left-column"><div class="chapter-title-corner-decoration-left-column"><img alt="image" class="chapter-title-corner-decoration-left" src="d2d_images/chapter_title_corner_decoration_left.png"/></div></td><td class="chapter-title-corner-decoration-middle-column"> </td><td class="chapter-title-corner-decoration-right-column"><div class="chapter-title-corner-decoration-right-column"><img alt="image" class="chapter-title-corner-decoration-right" src="d2d_images/chapter_title_corner_decoration_right.png"/></div></td></tr></tbody></table><div class="chapter-title"><div class="chapter-title-decoration-above"><div class="chapter-title-decoration-above-inner"><img alt="image" class="chapter-title-decoration-above" src="d2d_images/chapter_title_above.png"/></div></div><h1 class="chapter-title">La vita a terra</h1>
<h1>Kevin Killiany</h1>
<div class="chapter-title-decoration-below"><div class="chapter-title-decoration-below-inner"><img alt="image" class="chapter-title-decoration-below" src="d2d_images/chapter_title_below.png"/></div></div></div><p class="section-break">––––––––</p><div class="decoration-scene-break"><div class="decoration-scene-break-inner"><img alt="image" class="decoration-scene-break" src="d2d_images/scene_break.png"/></div></div>
<p style="font-size: large; text-align: center; text-indent: 0">Traduzione di Carmelo Massimo Tidona </p>
<p class="first-in-scene" style="font-size: small; page-break-before: always"><span class="first-scene-phrase"><span class="first-in-scene with-quote character-l">“L</span>a vita a terra”</span></p>
<p style="font-size: small">Autore Kevin Killiany</p>
<p style="font-size: small">Copyright © 2022 Kevin Killiany</p>
<p style="font-size: small">Tutti i diritti riservati</p>
<p style="font-size: small">Distribuito da Babelcube, Inc. </p>
<p style="font-size: small">www.babelcube.com </p>
<p style="font-size: small">Traduzione di Carmelo Massimo Tidona</p>
<p style="font-size: small">Progetto di copertina © 2022 D. Robert Pease</p>
<p style="font-size: small">“Babelcube Books” e “Babelcube” sono marchi registrati Babelcube Inc.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c001.vue?51e40ed5